
import {  Component, FormModalMixins, Prop } from "@/lib";
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";
import CopyProductElement from "@/store/modules/shipment/declarecustoms/copyproductelement";

class SearchData {
  shippingNumber:string;
  productCode:string;
  productName:string;
  constructor() {
    this.shippingNumber = "";
  }
}

@Component
export default class CopyDeclarationElementModal extends FormModalMixins {
  @Prop({type: String}) targetShippingNumber: string;// 目标记录的运编号
  @Prop({type: String}) productCode: string;// 商品编号
  @Prop({type: String}) productName: string;// 商品编号
  model = new CopyProductElement();

  searchModel = new SearchData();
  loading: boolean = false;

  get record() {
    return this.$store.state.shipment.declarecustoms.copyProductElement;
  }

  get haveProductCode() {
    return !!this.productCode;
  }

  // 点击导入后，调用的action
  get okAction() {
    if (this.haveProductCode) {
      return "";
    }
    // if(this.model.declarationElementProductDtoList.length > 0) {
    //   return "shipment/declarecustoms/copyDeclarationElementProduct";
    // }
    return "shipment/declarecustoms/copyDeclarationElementProduct";
  }

  get rules() {
    return {
      declarationElementProductDtoList: [{ 
        required: true, 
        validator: (rule, value, callback) => {
          if (this.model.declarationElementProductDtoList && this.model.declarationElementProductDtoList.some(x => x.isCopy === true)) {
            return callback();
          }
          const message = this.L("app.CustomsDeclarationElement.SelectAtLeastOneImport");
          return callback(message);
        },
        trigger: 'change',

      }]
    }
  }

  created() {
    Object.assign(this.config,{
        labelWidth: 80,
        modelTitleL: "app.Action.Import",
        width: 850,
        okText: "app.Action.Import"

    })
  }

  get column() {
    let result = [
      this.$util.render.baseColumn("app.SystemCode.SequenceNo", 100, {type: "index", align: 'center'}),
      this.$util.render.baseColumn("app.CustomsDeclarationElement.CommodityCode", null, {key: "productCode", width: 120}),
      this.$util.render.baseColumn("app.CustomsDeclarationElement.ProductName", null, {key: "productName", width: 486})
    ];
    result.push(this.$util.render.baseColumn("app.CustomsDeclarationElement.IsCopy", null, {slot: "actions", width: 100, fixed: 'right'}))
    return result;
  }

  async query() {
    if (!this.searchModel.shippingNumber) {
      return;
    }
    if (this.targetShippingNumber === this.searchModel.shippingNumber) {
      this.$Modal.warning({
          title: this.L("MessageTitle.Tips"),
          content: this.L("app.CustomsDeclarationElement.NotCopyOneSelf")
      });
      return;
    }
    this.loading = true;
    this.searchModel.productCode = this.productCode;
    this.searchModel.productName = this.productName;
    this.$set(this.model, "declarationElementProductDto", null);
    try {
      this.model.declarationElementProductDtoList = await this.$store.dispatch("shipment/declarecustoms/getDeclarationElementProductByShippingNumber", this.searchModel);
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.config.isShow = false;
    this.model = new CopyProductElement();
    this.searchModel = new SearchData();
  }

  copyChange(isCopy, row) {
    if (this.haveProductCode) {
      if (isCopy) {
        this.model.declarationElementProductDtoList.forEach(item => {
          if (item.id !== row.id) {
            item.isCopy = false;
          }
        });
        this.$set(this.model, "declarationElementProductDto", row);
      } else {
        this.$set(this.model, "declarationElementProductDto", null);
      }
    }
  }
}

